import { payload } from "../../../../../node_modules/.pnpm/@sveltejs+kit@3.1.1_@opentelemetry+api@1.9.1_@sveltejs+vite-plugin-svelte@7.3.1_svelte@_5bef44ea768adee32db76b40b422b33d/node_modules/@sveltejs/kit/src/runtime/client/payload.js";
const env = payload.env;

export const PUBLIC_OTEL_SERVICE_NAME = env.PUBLIC_OTEL_SERVICE_NAME;
export const PUBLIC_DD_VERSION = env.PUBLIC_DD_VERSION;
export const PUBLIC_DD_ENV = env.PUBLIC_DD_ENV;
export const PUBLIC_OTEL_EXPORTER_OTLP_PUBLIC_ENDPOINT = env.PUBLIC_OTEL_EXPORTER_OTLP_PUBLIC_ENDPOINT;
export const PUBLIC_DD_CLIENT_TOKEN = env.PUBLIC_DD_CLIENT_TOKEN;
export const PUBLIC_DD_SERVICE = env.PUBLIC_DD_SERVICE;
export const PUBLIC_OTEL_EXPORTER_OTLP_ENDPOINT = env.PUBLIC_OTEL_EXPORTER_OTLP_ENDPOINT;
export const PUBLIC_FRONTEGG_CONVERSIONS_APP_ID = env.PUBLIC_FRONTEGG_CONVERSIONS_APP_ID;
export const PUBLIC_FRONTEGG_HOST = env.PUBLIC_FRONTEGG_HOST;
export const PUBLIC_SIGNUP_DISABLED_URL = env.PUBLIC_SIGNUP_DISABLED_URL;
export const PUBLIC_INTERCOM_APP_ID = env.PUBLIC_INTERCOM_APP_ID;
export const PUBLIC_HEAP_APP_ID = env.PUBLIC_HEAP_APP_ID;
export const PUBLIC_DD_APPLICATION_ID = env.PUBLIC_DD_APPLICATION_ID;
export const PUBLIC_DD_RUM_SAMPLE_RATE = env.PUBLIC_DD_RUM_SAMPLE_RATE;
export const PUBLIC_DD_RUM_SESSION_SAMPLE_RATE = env.PUBLIC_DD_RUM_SESSION_SAMPLE_RATE;
export const PUBLIC_GOOGLE_ANALYTICS_ID = env.PUBLIC_GOOGLE_ANALYTICS_ID;
export const PUBLIC_CONTENT_MODERATION_REDIRECT = env.PUBLIC_CONTENT_MODERATION_REDIRECT;
export const PUBLIC_DEFAULT_SCAN_DESTINATION = env.PUBLIC_DEFAULT_SCAN_DESTINATION;
export const PUBLIC_ONE_TRUST_CONVERSIONS_DOMAIN_ID = env.PUBLIC_ONE_TRUST_CONVERSIONS_DOMAIN_ID;
export const PUBLIC_GENERATOR_URL = env.PUBLIC_GENERATOR_URL;
export const PUBLIC_COOKIE_NAME = env.PUBLIC_COOKIE_NAME;
export const PUBLIC_INTERNAL_ORG_ID = env.PUBLIC_INTERNAL_ORG_ID;
export const PUBLIC_CDN_URL = env.PUBLIC_CDN_URL;
export const PUBLIC_HOSTNAME = env.PUBLIC_HOSTNAME;
export const PUBLIC_LOG_LEVEL = env.PUBLIC_LOG_LEVEL;
export const PUBLIC_OPTIMIZELY_ID = env.PUBLIC_OPTIMIZELY_ID;
export const PUBLIC_AUDIT_URL = env.PUBLIC_AUDIT_URL;
export const PUBLIC_CODES_URL = env.PUBLIC_CODES_URL;
export const PUBLIC_PIXEL_TRACKER_URL = env.PUBLIC_PIXEL_TRACKER_URL;
export const PUBLIC_SHORT_URLS_URL = env.PUBLIC_SHORT_URLS_URL;
export const PUBLIC_BUNDLES_URL = env.PUBLIC_BUNDLES_URL;
export const PUBLIC_PAGES_URL = env.PUBLIC_PAGES_URL;
export const PUBLIC_FORMS_URL = env.PUBLIC_FORMS_URL;
export const PUBLIC_REGISTRY_URL = env.PUBLIC_REGISTRY_URL;
export const PUBLIC_STATIC_ASSET_URL = env.PUBLIC_STATIC_ASSET_URL;
export const PUBLIC_BRAND_URL = env.PUBLIC_BRAND_URL;
export const PUBLIC_TAG_URL = env.PUBLIC_TAG_URL;
export const PUBLIC_FOLDERS_URL = env.PUBLIC_FOLDERS_URL;
export const PUBLIC_POSIEDON_URL = env.PUBLIC_POSIEDON_URL;
export const PUBLIC_PRODUCT_URL = env.PUBLIC_PRODUCT_URL;
export const PUBLIC_SEARCH_URL = env.PUBLIC_SEARCH_URL;
export const PUBLIC_LINKS_URL = env.PUBLIC_LINKS_URL;
export const PUBLIC_STATUS_URL = env.PUBLIC_STATUS_URL;
export const PUBLIC_WEBHOOKS_URL = env.PUBLIC_WEBHOOKS_URL;
export const PUBLIC_NOTIFICATION_TEMPLATE_URL = env.PUBLIC_NOTIFICATION_TEMPLATE_URL;
export const PUBLIC_NOTIFICATIONS_URL = env.PUBLIC_NOTIFICATIONS_URL;
export const PUBLIC_INTEGRATIONS_URL = env.PUBLIC_INTEGRATIONS_URL;
export const PUBLIC_ABACUS_URL = env.PUBLIC_ABACUS_URL;
export const PUBLIC_LLM_URL = env.PUBLIC_LLM_URL;
export const PUBLIC_F1_APP_URL = env.PUBLIC_F1_APP_URL;
export const PUBLIC_BILLING_URL = env.PUBLIC_BILLING_URL;
export const PUBLIC_CONVERSIONS_DEVELOPERS_URL = env.PUBLIC_CONVERSIONS_DEVELOPERS_URL;
export const PUBLIC_SCANABILITY_URL = env.PUBLIC_SCANABILITY_URL;
export const PUBLIC_LEGAL_URL = env.PUBLIC_LEGAL_URL;
export const PUBLIC_ONBOARDING_URL = env.PUBLIC_ONBOARDING_URL;
export const PUBLIC_EVENTS_URL = env.PUBLIC_EVENTS_URL;
export const PUBLIC_COMPLIANCE_URL = env.PUBLIC_COMPLIANCE_URL;
export const PUBLIC_POLLS_URL = env.PUBLIC_POLLS_URL;
export const PUBLIC_CLUSTER_ABACUS_URL = env.PUBLIC_CLUSTER_ABACUS_URL;
export const PUBLIC_CLUSTER_AUDIT_URL = env.PUBLIC_CLUSTER_AUDIT_URL;
export const PUBLIC_CLUSTER_CODES_URL = env.PUBLIC_CLUSTER_CODES_URL;
export const PUBLIC_CLUSTER_SHORT_URLS_URL = env.PUBLIC_CLUSTER_SHORT_URLS_URL;
export const PUBLIC_CLUSTER_BUNDLES_URL = env.PUBLIC_CLUSTER_BUNDLES_URL;
export const PUBLIC_CLUSTER_PAGES_URL = env.PUBLIC_CLUSTER_PAGES_URL;
export const PUBLIC_CLUSTER_FORMS_URL = env.PUBLIC_CLUSTER_FORMS_URL;
export const PUBLIC_CLUSTER_REGISTRY_URL = env.PUBLIC_CLUSTER_REGISTRY_URL;
export const PUBLIC_CLUSTER_STATIC_ASSET_URL = env.PUBLIC_CLUSTER_STATIC_ASSET_URL;
export const PUBLIC_CLUSTER_BRAND_URL = env.PUBLIC_CLUSTER_BRAND_URL;
export const PUBLIC_CLUSTER_STATUS_URL = env.PUBLIC_CLUSTER_STATUS_URL;
export const PUBLIC_CLUSTER_TAG_URL = env.PUBLIC_CLUSTER_TAG_URL;
export const PUBLIC_CLUSTER_POSIEDON_URL = env.PUBLIC_CLUSTER_POSIEDON_URL;
export const PUBLIC_CLUSTER_INTEGRATIONS_URL = env.PUBLIC_CLUSTER_INTEGRATIONS_URL;
export const PUBLIC_CLUSTER_PRODUCT_URL = env.PUBLIC_CLUSTER_PRODUCT_URL;
export const PUBLIC_CLUSTER_SEARCH_URL = env.PUBLIC_CLUSTER_SEARCH_URL;
export const PUBLIC_CLUSTER_LINKS_URL = env.PUBLIC_CLUSTER_LINKS_URL;
export const PUBLIC_CLUSTER_FOLDERS_URL = env.PUBLIC_CLUSTER_FOLDERS_URL;
export const PUBLIC_CLUSTER_WEBHOOKS_URL = env.PUBLIC_CLUSTER_WEBHOOKS_URL;
export const PUBLIC_CLUSTER_NOTIFICATION_TEMPLATE_URL = env.PUBLIC_CLUSTER_NOTIFICATION_TEMPLATE_URL;
export const PUBLIC_CLUSTER_NOTIFICATIONS_URL = env.PUBLIC_CLUSTER_NOTIFICATIONS_URL;
export const PUBLIC_CLUSTER_BILLING_URL = env.PUBLIC_CLUSTER_BILLING_URL;
export const PUBLIC_CLUSTER_CONVERSIONS_DEVELOPERS_URL = env.PUBLIC_CLUSTER_CONVERSIONS_DEVELOPERS_URL;
export const PUBLIC_CLUSTER_PIXEL_TRACKER_URL = env.PUBLIC_CLUSTER_PIXEL_TRACKER_URL;
export const PUBLIC_CLUSTER_LEGAL_URL = env.PUBLIC_CLUSTER_LEGAL_URL;
export const PUBLIC_CLUSTER_ONBOARDING_URL = env.PUBLIC_CLUSTER_ONBOARDING_URL;
export const PUBLIC_CLUSTER_EVENTS_URL = env.PUBLIC_CLUSTER_EVENTS_URL;
export const PUBLIC_CLUSTER_COMPLIANCE_URL = env.PUBLIC_CLUSTER_COMPLIANCE_URL;
export const PUBLIC_CLUSTER_POLLS_URL = env.PUBLIC_CLUSTER_POLLS_URL;
export const PUBLIC_CLUSTER_LLM_URL = env.PUBLIC_CLUSTER_LLM_URL;
export const PUBLIC_EXTERNAL_STARTER_TEMPLATE_ID = env.PUBLIC_EXTERNAL_STARTER_TEMPLATE_ID;
export const PUBLIC_CRM_STARTER_TEMPLATE_ID = env.PUBLIC_CRM_STARTER_TEMPLATE_ID;
export const PUBLIC_MAPBOX_ACCESS_TOKEN = env.PUBLIC_MAPBOX_ACCESS_TOKEN;
export const PUBLIC_STRIPE_KEY = env.PUBLIC_STRIPE_KEY;
